import type { IconProps } from './Icon.types';

const ChevronDown: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width = 11,
}) => {
  const height = width * 0.73;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 11 8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.21967 1.0644C0.512563 0.771503 0.987437 0.771503 1.28033 1.0644L5.25 5.03407L9.21967 1.0644C9.51256 0.771503 9.98744 0.771503 10.2803 1.0644C10.5732 1.35729 10.5732 1.83216 10.2803 2.12506L5.25 7.15539L0.21967 2.12506C-0.0732233 1.83216 -0.0732233 1.35729 0.21967 1.0644Z"
        fill={fill}
      />
    </svg>
  );
};

export default ChevronDown;
